export class CallHistoryChangeAutomaticFilteringOnIncomingCall {
   public static readonly type = '[CallHistorySettings] Change automatic filtering on incoming call';

   constructor(public brickInstanceId, public automaticFilteringOnIncomingCall: boolean) {}
}

export class CallHistoryChangeRetainFilterOnCallFinish {
   public static readonly type = '[CallHistorySettings] Change retain filter on call finish';

   constructor(public brickInstanceId, public retainFilterOnCallFinish: boolean) {}
}

export class CallHistoryChangeShowPrimaryFullDateFormat {
   public static readonly type = '[CallHistorySettings] Change show primary full date format';

   constructor(public brickInstanceId, public showPrimaryFullDateFormat: boolean) {}
}
